import { render } from "./Tab.vue?vue&type=template&id=36b0c366&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=36b0c366&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b0c366"]])

export default __exports__